const React = require('react');
const T = require('prop-types');

const { default: Box } = require('@mui/material/Box');
const { default: Typography } = require('@mui/material/Typography');
const { default: Paper } = require('@mui/material/Paper');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: ArrowBackIcon } = require('@mui/icons-material/ArrowBack');
const { default: EditNoteIcon } = require('@mui/icons-material/EditNote');
const { default: ImageIcon } = require('@mui/icons-material/Image');

module.exports = function AdminOfferCreateMethodPage(props) {

    const { history } = props;

    return (
        <Box sx={{ p: 2, maxWidth: 720, mx: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <IconButton onClick={() => history.push('/app/admin/offers')} aria-label='Back'>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant='h5' sx={{ fontWeight: 700, ml: 1 }}>
                    New Offer
                </Typography>
            </Box>

            <Typography variant='body1' color='text.secondary' sx={{ mb: 3 }}>
                Choose how you want to create this offer.
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                <Paper
                    variant='outlined'
                    onClick={() => history.push('/app/admin/offers/create/manual')}
                    sx={{
                        flex: 1,
                        p: 3,
                        cursor: 'pointer',
                        transition: 'border-color 0.2s, box-shadow 0.2s',
                        '&:hover': {
                            borderColor: 'primary.main',
                            boxShadow: 2
                        }
                    }}
                >
                    <EditNoteIcon color='primary' sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant='h6' sx={{ fontWeight: 700, mb: 1 }}>
                        Manual Offer Creation
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                        Enter brand, content, CTA, and scheduling details field by field.
                    </Typography>
                </Paper>

                <Paper
                    variant='outlined'
                    onClick={() => history.push('/app/admin/offers/create/upload')}
                    sx={{
                        flex: 1,
                        p: 3,
                        cursor: 'pointer',
                        transition: 'border-color 0.2s, box-shadow 0.2s',
                        '&:hover': {
                            borderColor: 'primary.main',
                            boxShadow: 2
                        }
                    }}
                >
                    <ImageIcon color='primary' sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant='h6' sx={{ fontWeight: 700, mb: 1 }}>
                        Upload Image
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                        Upload a promotional image or paste an image URL, then configure the CTA, schedule, redemption settings and targeting rules below.
                    </Typography>
                </Paper>
            </Box>
        </Box>
    );
};

module.exports.propTypes = {
    history: T.object
};
